<app-delegation-period
  [start]="delegation().start"
  [end]="delegation().end"
  [status]="delegation().status.value"
  [clickable]="false"
  heading="labels.route"
  [driverHomeAddress]="driverHomeAddress()"
  [driverAssignedBaseAddress]="driverAssignedBaseAddress()"
  [relatedFleetSwap]="delegation().relatedFleetSwap"
  (edit)="edit()"
  (openDelegationActionModal)="openDelegationActionModal()"
></app-delegation-period>

@if (isPlanned() || isActive()) {
  <app-drivers-tachograph
    [primaryDriver]="delegation().primaryDriver"
    [secondaryDriver]="delegation().secondaryDriver"
    type="vehicle"
    format="full"
  ></app-drivers-tachograph>

  <app-modal-vehicles
    [vehicle]="delegation().vehicle"
    [trailer]="delegation().trailer"
    [uuid]="delegation().uuid"
    [close$]="close$()"
    (edit)="edit()"
  ></app-modal-vehicles>

  <app-modal-swap
    [vehicleUuid]="delegation().vehicle.uuid"
    [swapUuid]="delegation().relatedFleetSwap?.uuid ?? null"
    [close$]="close$()"
  ></app-modal-swap>
} @else {
  <app-modal-realized-by [delegation]="delegation()"></app-modal-realized-by>
}
